import { AgentOfficeApiFields } from "globalConstants";

const { clientId, clientSecret } = AgentOfficeApiFields;

export const mapAgentOfficeApiData = data => ({
	[clientId.name]: data[clientId.beName],
	[clientSecret.name]: data[clientSecret.beName],
});
